import { ApiResponseStatusGlobalDisplay } from 'components/ApiResponseStatusGlobalDisplay/ApiResponseStatusGlobalDisplay';
import { FunctionComponent, PropsWithChildren } from 'react';

import { Header } from './Header/Header';
import { LateralMenu } from './LateralMenu/LateralMenu';
import { BodyContainer, LayoutContainer, MainContainer } from './Layout.style';
import { useDeviceCategory } from './useDeviceCategory';

export const Layout: FunctionComponent<PropsWithChildren> = (props) => {
  const { isMobileAndTablet } = useDeviceCategory();
  return (
    <LayoutContainer>
      {!isMobileAndTablet ? <LateralMenu /> : ''}
      <BodyContainer>
        <Header />
        <MainContainer>{props.children}</MainContainer>
        <ApiResponseStatusGlobalDisplay />
      </BodyContainer>
    </LayoutContainer>
  );
};
